import { render, staticRenderFns } from "./PropertiesAmountsInputs.vue?vue&type=template&id=2176389d"
import script from "./PropertiesAmountsInputs.vue?vue&type=script&lang=js"
export * from "./PropertiesAmountsInputs.vue?vue&type=script&lang=js"
import style0 from "./PropertiesAmountsInputs.vue?vue&type=style&index=0&id=2176389d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports